import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostSyncOrganizationSecurityAlertsRequest = {
	organizationId: number;
};

export const postSyncOrganizationSecurityAlerts = createPostEndpoint<PostSyncOrganizationSecurityAlertsRequest>(
	'/api/v3/demo/dreamforce/create-metrics'
);
